import { IntegrationProvider } from 'integrations/types'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'

const usePushChampions = (): ((props: { provider: IntegrationProvider; personIds: number[] }) => Promise<void>) => {
  const [request] = useFetchRefactored<void>({
    successMessage: 'Champions send to integration sync',
    errorMessage: 'Failed to send champions to integration sync',
    useNewNotification: true,
  })
  const org = useCurrentOrg()

  return useCallback(
    async ({ provider, personIds }: { provider: IntegrationProvider; personIds: number[] }) => {
      return request({
        method: 'post',
        url: `/organizations/${org.id}/push-champions/${provider}`,
        config: {
          body: {
            personIds,
          },
        },
      })
    },
    [org.id, request],
  )
}

export default usePushChampions
